import styled from 'styled-components';
import { Avatar as AvatarBase, Tooltip } from '@mui/material';
import { getAvatarColors, getFirstLettersOfName } from '../../utils/common';

type Size = 'extraSmall' | 'small' | 'medium' | 'large';

const AvatarStyled = styled(AvatarBase)<{
  $size: Size;
}>`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};

  ${({ $size, theme }) =>
    $size === 'extraSmall'
      ? `
      width: 16px;
      height: 16px;
      font-size: ${theme.tokens.components.avatar.extraSmallFontSize};
      `
      : $size === 'small'
      ? `
      width: 20px;
      height: 20px;
      font-size: ${theme.tokens.fontSize.xxxs};
      `
      : $size === 'medium'
      ? `
      width: 22px;
      height: 22px;
      font-size: ${theme.tokens.fontSize.xxs};
      `
      : $size === 'large'
      ? `
      width: 32px;
      height: 32px;
      font-size: ${theme.tokens.fontSize.sm};
      `
      : `
      width: 22px;
      height: 22px;
      font-size: ${theme.tokens.fontSize.xxs};
      `}
`;

type Props = {
  value: { id?: string; name: string };
  tooltip?: string;
  size?: 'extraSmall' | 'small' | 'medium' | 'large';
};

const Avatar = ({ value, tooltip, size = 'medium' }: Props) => (
  <Tooltip title={tooltip}>
    <AvatarStyled
      sx={(theme) => {
        const colors = getAvatarColors(value.id || value.name, theme);
        return { background: colors.background, color: colors.text };
      }}
      $size={size}
    >
      {getFirstLettersOfName(value.name)}
    </AvatarStyled>
  </Tooltip>
);

export default Avatar;
